export enum PlayMode {
  SHUFFLE = 'shuffle',
  NORMAL = 'normal',
  REPEAT = 'repeat',
}
